<template>
  <b-overlay
    variant="white"
    spinner-variant="primary"
    blur="0"
    opacity=".75"
    rounded="sm"
    :show="loading"
  >
    <DeleteDocumentTypeModal
      :document-type="documentTypeToBeChanged"
      @deleted="fetch"
      @hidden="documentTypeToBeChanged = undefined"
    />
    <DocumentTypeForm
      :document-type="documentTypeToBeChanged"
      @document-type-created="fetch"
      @hidden="documentTypeToBeChanged = undefined"
    />
    <b-card>
      <b-button
        class="mb-1"
        variant="primary"
        @click="openDocumentTypeModal"
      >
        Create new document type
      </b-button>
      <b-table
        striped
        :items="list"
        :fields="tableColumns"
        show-empty
        empty-text="Empty"
      >
        <template #cell(actions)="data">
          <b-button
            class="btn-icon rounded-circle"
            variant="flat-primary"
            @click="openUpdateDocumentTypeModal(data.item)"
          >
            <feather-icon
              icon="EditIcon"
            />
          </b-button>
          <b-button
            class="btn-icon rounded-circle"
            variant="flat-danger"
            @click="openDeleteDocumentTypeModal(data.item)"
          >
            <feather-icon
              icon="TrashIcon"
            />
          </b-button>
        </template>
      </b-table>
      <base-pagination
        v-model="queryParams.page"
        class="mt-1"
        :total="total"
        @input="fetch"
        @new-per-page="queryParams.perPage = $event"
      />
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BCard, BTable, BOverlay, BButton,
} from 'bootstrap-vue'
import {
  reactive, ref, toRef, watch,
} from '@vue/composition-api'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import businessStore from '../store'
import { formatDate } from '@/@core/utils/filter'
import BasePagination from '@/UI/BasePagination.vue'
import DocumentTypeForm from '../components/document-types/DocumentTypeForm.vue'
import snakeCaseToCamelCase from '@/utils/snake-case-to-camcel-caase'
import DeleteDocumentTypeModal from '../components/document-types/DeleteDocumentTypeModal.vue'

export default {
  components: {
    BCard, BTable, BOverlay, BasePagination, BButton, DocumentTypeForm, DeleteDocumentTypeModal,
  },
  setup(_, ctx) {
    useRegisterStoreModule('business', businessStore)

    const documentTypeToBeChanged = ref()

    const tableColumns = [
      {
        label: 'Name',
        key: 'name',
        formatter: val => val.en,
      },
      {
        label: 'created at',
        key: 'createdAt',
        formatter: val => formatDate(val),
      },
      {
        label: 'updated at',
        key: 'updatedAt',
        formatter: val => formatDate(val),
      },
      {
        label: 'Required',
        key: 'required',
        formatter: val => (val ? 'Yes' : 'No'),
      },
      {
        label: 'Resource Type',
        key: 'resourceType',
        formatter: val => snakeCaseToCamelCase(val),
      },
      'actions',
    ]
    const loading = ref(false)
    const list = ref([])
    const total = ref(0)

    const queryParams = reactive({
      perPage: 10,
      page: 1,
    })

    const fetch = async () => {
      loading.value = true
      const res = await ctx.root.$store.dispatch('business/getAllDocumentTypes', { params: queryParams })
      const { data } = res.data
      list.value = data
      loading.value = false
    }

    fetch()

    watch([toRef(queryParams, 'perPage')], () => {
      fetch()
    })
    const openDocumentTypeModal = () => ctx.root.$bvModal.show('document-types-form-modal')
    const openDeleteDocumentTypeModal = docType => {
      documentTypeToBeChanged.value = { ...docType }
      ctx.root.$bvModal.show('delete-document-type-modal')
    }
    const openUpdateDocumentTypeModal = docType => {
      documentTypeToBeChanged.value = { ...docType }
      setTimeout(() => {
        openDocumentTypeModal()
      }, 0)
    }

    return {
      openUpdateDocumentTypeModal,
      openDocumentTypeModal,
      openDeleteDocumentTypeModal,
      list,
      total,
      fetch,
      loading,
      queryParams,
      documentTypeToBeChanged,
      tableColumns,
    }
  },
}
</script>
